import { UserSearchDto } from '../../../users/shared/dto/user-search.dto';
import { AccessControlEntry } from '../../../shared/auth/access-control-entry';
import { SecurityElementNames } from '../../../shared/auth/constants/security-element-names.service';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ProfileRead } from '../../shared/profile-read.model';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { ProfileStatusService } from '../../profile-status/profile-status.service';
import { ProfileStatus } from '../../profile-status/profile-status.model';
import { UserService } from '../../../users/shared/user.service';
import { UserRead } from '../../../users/shared/user-read.model';
import { PagedSearch, TranslationService } from '../../../shared';
import { SelectItem } from 'primeng/api';
import { ProfileService } from '../../shared/profile.service';
import { ProfileRelationSearch } from '../../shared/profile-relation-search.model';
import { ProfileAddress } from '../../shared/profileAddress.model';
import { ConfigSettingService } from 'src/app/config/shared/config-setting/config-setting.service';
import { DefaultPhone } from '../../shared/enum/default-phone.enum';

@Component({
  selector: 'wl-profile-edit-general',
  templateUrl: 'profile-edit-general.component.html',
  styleUrls: ['profile-edit-general.component.less'],
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditGeneralComponent),
    CreateObjectValueValidationProvider(ProfileEditGeneralComponent),
  ],
    standalone: false
})
export class ProfileEditGeneralComponent extends ObjectValueAccessor<ProfileRead> implements OnInit, OnChanges {
  @Input() profileId: number;
  public profileStatuses: Array<ProfileStatus>;
  public allUsers: Array<UserRead>;
  public detailsAccessControl: AccessControlEntry = {
    SecurityElement: this.securityElementNames.ProfileDetails_Tab,
    MinimumAccessLevel: 2,
  };
  inheritAddress: boolean = false;
  inheritPhone: boolean = false;
  relatedProfileItems: SelectItem[] = [];
  originalAddress: ProfileAddress = new ProfileAddress();
  inheritedAddress: ProfileAddress = new ProfileAddress();
  useProfileExternalId: boolean = false;
  profileExternalIdName: string = '';
  updatingRelatedProfileItems: boolean = false;
  defaultPhoneItems: Array<SelectItem> = [];
  public constructor(
    public securityElementNames: SecurityElementNames,
    private _profileStatusService: ProfileStatusService,
    private _userService: UserService,
    private _profileService: ProfileService,
    private _configSettingService: ConfigSettingService,
    private _translationService: TranslationService
  ) {
    super(new ProfileRead(), false);

    this.profileStatuses = [];
  }

  ngOnInit() {
    this.defaultPhoneItems = [
      {
        value: DefaultPhone.Work,
        label: this._translationService.getInstantTitlecase('common.personal-information.work-phone'),
      } as SelectItem,
      {
        value: DefaultPhone.Home,
        label: this._translationService.getInstantTitlecase('common.personal-information.home-phone'),
      } as SelectItem,
      {
        value: DefaultPhone.Cell,
        label: this._translationService.getInstantTitlecase('common.personal-information.cell-phone'),
      } as SelectItem,
    ];

    this._profileStatusService.getProfileStatuses({ PageNumber: 0, PageSize: 0 }).then((data) => {
      this.profileStatuses = data.Result.sort((x, y) => {
        if (x.MemberType1 > y.MemberType1) {
          return 1;
        }
        if (x.MemberType1 < y.MemberType1) {
          return -1;
        }
        return 0;
      });
    });

    this._userService.search({ PageNumber: 0, PageSize: 0, OrderBy: 'UserName:ASC' } as UserSearchDto).then((data) => {
      this.allUsers = data.Result;
    });

    this._configSettingService.getConfigSettingByName('UseProfileExternalId').then((UseProfileExternalId) => {
      if (UseProfileExternalId?.SettingValue.toLowerCase() === 'true') {
        this.useProfileExternalId = true;
        this._configSettingService.getConfigSettingByName('ProfileExternalIdName').then((profileExternalIdName) => {
          this.profileExternalIdName = profileExternalIdName.SettingValue;
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profileId && parseInt(changes.profileId.currentValue) > 0) {
      this.updatingRelatedProfileItems = true;
      this.relatedProfileItems = [];
      this._profileService
        .getProfileViewPrimaryRelations({ ProfileId: this.profileId, PageSize: 0 } as ProfileRelationSearch)
        .then((result) => {
          this.relatedProfileItems = result.Result.map((relation) => {
            return { label: relation.ReportName, value: relation.ProfileId };
          });
        })
        .finally(() => {
          this.updatingRelatedProfileItems = false;
        });
    }
  }

  public profileChanged(profileChanged) {
    if (profileChanged.InheritAddressFrom > 0) {
      this.inheritAddress = true;
    }

    if (profileChanged.InheritPhoneFrom > 0) {
      this.inheritPhone = true;
    }
  }

  toggleInheritAddress() {
    if (!this.inheritAddress) {
      this.value.InheritAddressFrom = 0;
    }
  }
  toggleInheritPhone() {
    if (!this.inheritPhone) {
      this.value.InheritPhoneFrom = 0;
    }
  }
}
